/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dropdown } from 'antd'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Box, Link } from 'widgets'
import { useTranslation } from 'contexts/Localization'

const MenuDropdown = styled.div`
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      transition: 0.25s;

      img {
        width: 20px;
        margin-right: 5px;

        &.light {
          display: none;
        }

        &.dark {
          display: inline;
        }
      }

      &:hover {
        background: #fff;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
      }

      &.active {
        img {
          &.light {
            display: inline;
          }

          &.dark {
            display: none;
          }
        }
        a {
          color: #006dfe;
        }
      }

      a {
        display: block;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 8px;
        color: #000000;
        padding: 15px 12px;
      }

      &.active {
        a {
          color: #006dfe;
        }
      }
    }
  }
`

interface Props {
  entry: any
  isActive: boolean
  paths: any
  refContainerDropdown: any
}

const DropMenuText: React.FC<Props> = ({ entry, isActive, paths, refContainerDropdown, ...props }) => {
  const { t } = useTranslation()

  const [visibleDropdown, setVisibleDropdown] = useState(false)

  const handleVisibleChange = (flag: boolean) => {
    setVisibleDropdown(flag)
  }

  return (
    <>
      <Dropdown
        {...props}
        open={visibleDropdown}
        onOpenChange={handleVisibleChange}
        overlay={
          <MenuDropdown>
            <ul>
              {entry.items.map((subMenu) => {
                const subMenuActive = subMenu?.actives?.includes(paths[2])

                return (
                  <Box
                    as="li"
                    key={subMenu.label}
                    className={subMenuActive ? 'active' : ''}
                    onClick={() => setVisibleDropdown((prev) => !prev)}
                  >
                    {subMenu.href ? (
                      <Link href={subMenu.href} target={subMenu.target}>
                        <img className="dark" src={`/images/icons/${subMenu.icon}`} alt="" />
                        <img className="light" src={`/images/icons/${subMenu.iconLight}`} alt="" />
                        {t(subMenu.label)}
                      </Link>
                    ) : (
                      <a target={subMenu.target}>
                        <img className="dark" src={`/images/icons/${subMenu.icon}`} alt="" />
                        <img className="light" src={`/images/icons/${subMenu.iconLight}`} alt="" />
                        {t(subMenu.label)}
                      </a>
                    )}
                  </Box>
                )
              })}
            </ul>
          </MenuDropdown>
        }
        placement="bottom"
        trigger={['click']}
        getPopupContainer={() => refContainerDropdown.current}
      >
        <li key={entry.label} className={isActive || visibleDropdown ? 'active' : ''}>
          {entry.href ? (
            <>
              <Link href={entry.href} target={entry.target}>
                {t(entry.label)}
              </Link>
              <Link className="shadow" href={entry.href} target={entry.target}>
                {t(entry.label)}
              </Link>
            </>
          ) : (
            <>
              <a target={entry.target}>{t(entry.label)}</a>
              <a className="shadow" target={entry.target}>
                {t(entry.label)}
              </a>
            </>
          )}
        </li>
      </Dropdown>
    </>
  )
}

export default DropMenuText
